// https://www.i18next.com/translation-function/context
export const CONTEXT_MALE_VALUE = "male";
export const CONTEXT_FEMALE_VALUE = "female";

export const ITEM_GENDER_CONTEXT = {
  ACTIVITY: CONTEXT_FEMALE_VALUE,
  ASSET: CONTEXT_MALE_VALUE,
  ASSET_TYPE: CONTEXT_MALE_VALUE,
  INTERVENTION: CONTEXT_FEMALE_VALUE,
  LOCATION: CONTEXT_FEMALE_VALUE,
  OBSERVATION: CONTEXT_FEMALE_VALUE,
  ORGANIZATION: CONTEXT_FEMALE_VALUE,
  PROJECT: CONTEXT_MALE_VALUE,
  TEMPLATE: CONTEXT_MALE_VALUE,
  USER: CONTEXT_MALE_VALUE,
  COMMENT: CONTEXT_MALE_VALUE,
  RECOMMENDATION: CONTEXT_FEMALE_VALUE,
} as const;
